import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 257 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Generated with Avocode.", -1),
    _createElementVNode("path", {
      fill: "#254a9c",
      d: "m178.388 127.837 67.7-67.714c13.489-13.476 13.489-35.528 0-49.004l-.83-.829c-13.474-13.49-35.526-13.49-49.003 0L128.54 78.004 60.827 10.29C47.35-3.2 25.299-3.2 11.809 10.276l-.83.843c-13.475 13.476-13.475 35.528 0 49.004l67.716 67.714-67.715 67.714c-13.476 13.477-13.476 35.541 0 49.005l.829.842c13.49 13.477 35.542 13.477 49.018 0l67.714-67.728 67.714 67.728c13.477 13.477 35.529 13.477 49.004 0l.829-.842c13.489-13.464 13.489-35.528 0-49.005z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "cross"}) } }